import React, { useEffect, useState, } from "react";
import axios from "axios";
import { Spin } from "antd";
import {  useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {

  PlusOutlined,
  ExperimentOutlined,
  DeleteOutlined

} from "@ant-design/icons";

function CourseContentLayoutInstructor({
  CourseName,
  BatchName,
  BatchType,
}) {
  const [loading, setLoading] = useState(true);
  const [groupedModules, setGroupedModules] = useState({});
  const [activeModule, setActiveModule] = useState(null);
    const [uploading, setUploading] = useState(false);
   

      const [isExtraClassModalOpen, setIsExtraClassModalOpen] = useState(false);
const [selectedClass, setSelectedClass] = useState(null);
const [newClassName, setNewClassName] = useState("");
const [creatingClass, setCreatingClass] = useState(false);

const [isDeleteClassModalOpen, setIsDeleteClassModalOpen] = useState(false);
const [deleteClassInput, setDeleteClassInput] = useState("");
const [deletingClass, setDeletingClass] = useState(false);
const [classToDelete, setClassToDelete] = useState(null);
    

 const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);


 
  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/course-content/get-course-content`,
        {
          CourseName,
          BatchName,
          BatchType,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        const data = res.data.data;

        // 🔥 Group by ModuleNumber
        const grouped = data.reduce((acc, item) => {
          if (!acc[item.ModuleNumber]) {
            acc[item.ModuleNumber] = {
              moduleName: item.ModuleName,
              classes: [],
            };
          }
          acc[item.ModuleNumber].classes.push(item);
          return acc;
        }, {});

        setGroupedModules(grouped);

        // Only set first module if activeModule is not already set
if (!activeModule) {
  const sortedModules = Object.keys(grouped)
    .map(Number)
    .sort((a, b) => a - b);

  if (sortedModules.length > 0) {
    setActiveModule(sortedModules[0]);
  }
}
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

   /* ================================
     📤 CSV Upload Handler
  ================================= */
  const handleCsvUpload = async (file) => {
    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/course-content/create-course-content/csv`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        toast.success("Course Content Uploaded Successfully ✅");
        fetchContent(); // reload content
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Upload failed ❌");
    } finally {
      setUploading(false);
    }
  };

  const moduleNumbers = Object.keys(groupedModules).map(Number);

  const toCamelCaseDisplay = (text) => {
  if (!text) return "";

  return text
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

  const noContent = moduleNumbers.length === 0;


  const createExtraClass = async () => {

  if (!newClassName.trim()) {
    toast.error("Class name required");
    return;
  }

  try {

    setCreatingClass(true);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course-content/create-course-content-after-id`,
      {
        CourseName: selectedClass.CourseName,
        BatchName: selectedClass.BatchName,
        BatchType: selectedClass.BatchType,
        ModuleNumber: selectedClass.ModuleNumber,
        ModuleName: selectedClass.ModuleName,
        ClassName: newClassName,
        Id: selectedClass.id
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (res.data.success) {

      toast.success(res.data.message);

      setIsExtraClassModalOpen(false);
      setNewClassName("");
      setSelectedClass(null);

      fetchContent(); // refresh UI
    }

  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed");
  } finally {
    setCreatingClass(false);
  }

};

const handleDeleteClass = async () => {
  if (!classToDelete?.id) {
    toast.error("Invalid class selected");
    return;
  }

  if (deleteClassInput.trim() !== classToDelete.ClassName) {
    toast.error("Class name does not match");
    return;
  }

  try {
    setDeletingClass(true);

    const res = await axios.delete(
      `${process.env.REACT_APP_API_URL}/course-content/delete-course-content/${classToDelete.id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data.success) {
      toast.success(res.data.message || "Class deleted successfully");

      setIsDeleteClassModalOpen(false);
      setDeleteClassInput("");
      setClassToDelete(null);

      await fetchContent();
    }
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to delete class");
  } finally {
    setDeletingClass(false);
  }
};


const launchLab = (moduleName) => {

  const module = moduleName?.toUpperCase();

  
   if (module.includes("WEB")) {
    window.open("http://100.83.200.31:8090/", "_blank");
    return;
  }
 if (module.includes("API")) {
    window.location.href = "postman://";
    return;
  }

  if (module.includes("ANDROID")) {
    window.location.href = "infoseclab-android://open";
    return;
  }

  if (module.includes("THICK")) {
    window.location.href = "infoseclab-thickclient://open";
    return;
  }

  alert("Lab not configured for this module.");
};


const getModuleProgress = (classes = []) => {
  const total = classes.length;
  const completed = classes.filter(
    (c) => c.ClassStatus === "COMPLETED"
  ).length;

  const percent = total ? Math.round((completed / total) * 100) : 0;

  let status = "YET TO START";
  if (completed === total && total > 0) status = "COMPLETED";
  else if (completed > 0) status = "IN PROGRESS";

  return { status, percent };
};

  return (
    <div className="flex min-h-screen bg-gray-50">

        <ToastContainer
                              position="bottom-left"
                              autoClose={5000}
                              hideProgressBar={true}
                              newestOnTop={false}
                              closeOnClick
                              rtl={false}
                              pauseOnFocusLoss
                              draggable
                              pauseOnHover
                              theme="dark"
                              className="!mb-6 !ml-4"
                              toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                            />

{/* ================= LEFT SIDEBAR ================= */}
<div className="relative h-screen px-6 py-8 overflow-y-auto font-sans bg-white border-r w-80">

  {moduleNumbers.map((moduleNo, index) => {
    const module = groupedModules[moduleNo];
    const isActive = activeModule === moduleNo;

    return (
      <div key={moduleNo} className="relative mb-8 ">

        {/* Vertical Dotted Line */}
        {index !== moduleNumbers.length - 1 && (
          <div className="absolute left-[18px] top-20 h-full border-l-2 border-dotted border-gray-300"></div>
        )}

        {/* MODULE CARD */}
        <div
          onClick={() => setActiveModule(moduleNo)}
          className={`
            relative
            rounded-xl
            p-5
            border
            cursor-pointer
            transition-all
            duration-200
            hover:-translate-y-0.5
            ${
              isActive
                ? "border-blue-500 bg-blue-50 shadow-sm"
                : "border-gray-200 bg-white hover:border-blue-400 hover:bg-blue-50/40"
            }
          `}
        >

          {/* MODULE NUMBER */}
          <div className="text-xs tracking-widest text-gray-500">
            MODULE - {moduleNo}
          </div>

          {/* MODULE NAME */}
          <div
            className={`
              mt-1
              text-lg
              font-semibold
              transition-colors
              ${isActive ? "text-blue-600" : "text-gray-900"}
            `}
          >
            {toCamelCaseDisplay(module.moduleName)}
          </div>

          {/* CLASSES BUTTON */}
          <div className="mt-4">
            <button
              onClick={(e) => {
                e.stopPropagation(); // prevent double trigger
                setActiveModule(moduleNo);
              }}
              className={`
                w-full
                flex
                items-center
                justify-between
                px-4
                py-2
                rounded-lg
                text-sm
                font-medium
                transition
                ${
                  isActive
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }
              `}
            >
              <span>Classes</span>
              {/* {isActive && <span>✓ Completed</span>} */}
            </button>
          </div>

          {/* MOCK INTERVIEW BLOCK */}
          {(() => {
  const { status, percent } = getModuleProgress(module.classes);

  const statusStyles = {
    "COMPLETED": "bg-green-100 text-green-700 border-green-300",
    "IN PROGRESS": "bg-yellow-100 text-yellow-700 border-yellow-300",
    "YET TO START": "bg-gray-100 text-gray-600 border-gray-300",
  };

  return (
    <div className={`mt-4 p-3 border-2 rounded-lg ${statusStyles[status]}`}>
      <div className="mb-1 text-xs font-bold tracking-wide">
        {status}
      </div>

      <div className="w-full h-2 overflow-hidden bg-gray-200 rounded-full">
        <div
          className="h-full transition-all bg-blue-600"
          style={{ width: `${percent}%` }}
        />
      </div>

      <div className="mt-1 text-[10px] font-semibold text-gray-600">
        {percent}% Completed
      </div>
    </div>
  );
})()}

          {/* RIGHT ARROW INDICATOR */}
          {isActive && (
            <div className="absolute -translate-y-1/2 -right-4 top-1/2">
              <div className="flex items-center justify-center w-8 h-8 text-white bg-blue-600 rounded-full shadow-md">
                →
              </div>
            </div>
          )}

        </div>
      </div>
    );
  })}

</div>

     {/* ================= RIGHT PANEL ================= */}
      <div className="flex items-start justify-center flex-1 px-16 py-12 font-sans bg-white">

        {loading ? (
          <Spin size="large" />
        ) : noContent ? (
  /* ================= EMPTY STATE ================= */
  <div className="flex items-center justify-center w-full py-20">
    <div className="max-w-xl p-10 text-center border border-gray-200 shadow-sm bg-gray-50 rounded-2xl">

      <div className="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-blue-100 rounded-full">
        <svg
          className="w-10 h-10 text-blue-600"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12h6m-6 4h6M7 8h10M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      </div>

      <h2 className="mb-4 text-3xl font-bold text-red-600">
        Course Content Not Yet Available
      </h2>

      <p className="mb-4 text-lg text-gray-600">
        The course structure, modules, and class sessions have not been uploaded
        for this batch yet.
      </p>

      <p className="mb-8 text-gray-500">
        Please contact the <span className="font-bold text-red-600">Operations Team</span> to
        request the course content upload. Once the Operations Team uploads the
        course curriculum, the modules and classes will automatically appear
        here for instructors and students to access.
      </p>

      {/* <label className="inline-block px-8 py-4 text-lg font-semibold text-white transition bg-blue-600 cursor-pointer rounded-xl hover:bg-blue-700">
        {uploading ? "Uploading..." : "Upload Course Content (CSV)"}
        <input
          type="file"
          accept=".csv"
          hidden
          onChange={(e) => handleCsvUpload(e.target.files[0])}
        />
      </label> */}

    </div>
  </div>
) : activeModule ? (
          /* ================= NORMAL CONTENT ================= */
          <div className="w-full">

            <div className="grid items-center grid-cols-2 mb-6">

  {/* LEFT SIDE */}
  <div>
    <h2 className="text-3xl font-bold text-black">
      {toCamelCaseDisplay(
        groupedModules[activeModule]?.moduleName
      )}
    </h2>

    <p className="mt-2 text-sm text-gray-500">
      {groupedModules[activeModule]?.classes.length} Classes
    </p>
  </div>

  {/* RIGHT SIDE */}
  <div className="flex justify-end">
 <button
  onClick={() =>
    launchLab(
      groupedModules[activeModule]?.moduleName
    )
  }
  className="flex items-center gap-3 px-5 py-3 text-xl font-bold text-white transition bg-blue-600 rounded-lg hover:bg-blue-700"
>

  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="white"
    className="w-6 h-6"
  >
    <path d="M9 2v2h1v5.586l-4.707 4.707A1 1 0 0 0 5 15v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3a1 1 0 0 0-.293-.707L14 9.586V4h1V2H9zm3 8 4 4H8l4-4z"/>
  </svg>

  Access Lab

</button>
  </div>

</div>

            {groupedModules[activeModule]?.classes.map((item) => (
              <div
                key={item.id}
                className="flex items-center justify-between py-8 border-b border-gray-200 group"
              >
               <div className="flex items-center gap-6">

  {/* DAY */}
  <div className="text-sm font-semibold text-gray-500 uppercase">
    Day {item.OrderNo}
  </div>

  {/* CLASS NAME + STATUS */}
  <div className="flex items-center gap-3">

    <button
      onClick={() => {
        const url = `/academy/mentor-dashboard/course/course-content/${item.CourseName}/modules/${item.id}/class`;
        window.open(url, "_blank");
      }}
      className="text-lg font-semibold transition duration-200 text-slate-900 group-hover:text-blue-700 hover:underline hover:underline-offset-4"
    >
      {toCamelCaseDisplay(item.ClassName)}
    </button>

    {/* STATUS BADGE */}
    <span
      className={`flex items-center gap-2 text-xs font-semibold px-3 py-1 rounded-full
        ${
          item.ClassStatus === "COMPLETED"
            ? "bg-green-100 text-green-700"
            : "bg-red-100 text-red-600"
        }
      `}
    >
      {item.ClassStatus === "COMPLETED" ? "✔ " : ""}
      {item.ClassStatus}
    </span>

  </div>

</div>

                 {/* ACTION BUTTONS */}
                <div className="flex items-center gap-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedClass(item);
                      setIsExtraClassModalOpen(true);
                    }}
                    className="flex items-center justify-center w-8 h-8 text-white transition bg-blue-600 border border-gray-300 rounded-full hover:bg-blue-700"
                    title="Add Extra Class"
                  >
                    +
                  </button>
                
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setClassToDelete(item);
                      setDeleteClassInput("");
                      setIsDeleteClassModalOpen(true);
                    }}
                    className="flex items-center justify-center w-8 h-8 text-white transition bg-red-500 border border-red-500 rounded-full hover:bg-red-600"
                    title="Delete Class"
                  >
                    <DeleteOutlined />
                  </button>
                </div>
              </div>
            ))}

          </div>
        ) : (
          <div>No modules available.</div>
        )}

      </div>


  {/* ================= ADD CLASS MODAL ================= */}
{isExtraClassModalOpen && selectedClass && (

<div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">

<div className="w-full max-w-2xl p-6 bg-white shadow-2xl rounded-2xl">

{/* ===== HEADER ===== */}
<div className="flex items-center justify-between pb-4 border-b border-slate-200">

<div className="flex items-center gap-3">

<div className="flex items-center justify-center bg-indigo-100 rounded-md w-9 h-9">
<PlusOutlined className="text-indigo-600"/>
</div>

<div>
<h2 className="text-lg font-semibold text-slate-900">
Create Extra Class
</h2>
<p className="text-xs text-slate-500">
Add a new class after this session
</p>
</div>

</div>

<button
onClick={() => setIsExtraClassModalOpen(false)}
className="text-lg text-slate-400 hover:text-slate-600"
>
✕
</button>

</div>

{/* ===== COURSE INFO ===== */}
<div className="grid grid-cols-2 gap-4 p-4 mt-5 text-sm border rounded-lg bg-blue-50 border-slate-200">

<InfoItem label="Course" value={selectedClass.CourseName}/>
<InfoItem label="Batch" value={`${selectedClass.BatchName} (${selectedClass.BatchType})`}/>
<InfoItem label="Module" value={selectedClass.ModuleNumber}/>
<InfoItem label="Module Name" value={selectedClass.ModuleName}/>

</div>

{/* ===== CLASS INPUT ===== */}
<div className="mt-5">

<label className="block mb-2 text-sm font-medium text-slate-700">
Class Name
</label>

<input
type="text"
value={newClassName}
onChange={(e)=>setNewClassName(e.target.value)}
placeholder="Enter new class name"
className="w-full px-3 py-2 text-sm border rounded-md border-slate-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
/>

</div>

{/* ===== ACTION BUTTONS ===== */}
<div className="flex justify-end gap-3 mt-6">

<button
onClick={()=>setIsExtraClassModalOpen(false)}
className="px-4 py-2 text-xs font-semibold transition rounded-md text-slate-600 bg-slate-100 hover:bg-slate-200"
>
Cancel
</button>

<button
onClick={createExtraClass}
disabled={creatingClass}
className={`px-4 py-2 text-xs font-semibold text-white rounded-md transition ${
creatingClass
? "bg-indigo-300 cursor-not-allowed"
: "bg-indigo-600 hover:bg-indigo-500"
}`}
>
{creatingClass ? "Creating..." : "Create Class"}
</button>

</div>

</div>
</div>

)}

{/* ================= DELETE CLASS MODAL ================= */}
{isDeleteClassModalOpen && classToDelete && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
    <div className="w-full max-w-2xl p-6 bg-white shadow-2xl rounded-2xl">

      {/* HEADER */}
      <div className="flex items-center justify-between pb-4 border-b border-slate-200">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center bg-red-100 rounded-md w-9 h-9">
            <DeleteOutlined className="text-red-600" />
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">
              Delete Class
            </h2>
            <p className="text-xs text-slate-500">
              Confirm this deletion by typing the exact class name
            </p>
          </div>
        </div>

        <button
          onClick={() => {
            setIsDeleteClassModalOpen(false);
            setDeleteClassInput("");
            setClassToDelete(null);
          }}
          className="text-lg text-slate-400 hover:text-slate-600"
        >
          ✕
        </button>
      </div>

      {/* CLASS INFO */}
      <div className="grid grid-cols-2 gap-4 p-4 mt-5 text-sm border border-red-200 rounded-lg bg-red-50">
        <InfoItem label="Course" value={classToDelete.CourseName} />
        <InfoItem
          label="Batch"
          value={`${classToDelete.BatchName} (${classToDelete.BatchType})`}
        />
        <InfoItem label="Module" value={classToDelete.ModuleNumber} />
        <InfoItem label="Order No" value={classToDelete.OrderNo} />
      </div>

      {/* CLASS TITLE */}
      <div className="p-4 mt-4 border rounded-lg bg-slate-50 border-slate-200">
        <p className="text-xs font-medium tracking-wide uppercase text-slate-400">
          Class Name
        </p>
        <p className="mt-1 text-base font-bold text-slate-900">
          {classToDelete.ClassName}
        </p>
      </div>

      {/* INPUT */}
      <div className="mt-5">
        <label className="block mb-2 text-sm font-medium text-slate-700">
          Type exact class name to enable delete
        </label>

        <input
          type="text"
          value={deleteClassInput}
          onChange={(e) => setDeleteClassInput(e.target.value)}
          placeholder="Enter exact class name"
          className="w-full px-3 py-2 text-sm border rounded-md border-slate-300 focus:outline-none focus:ring-2 focus:ring-red-500"
        />
      </div>

      {/* ACTION BUTTONS */}
      <div className="flex justify-end gap-3 mt-6">
        <button
          onClick={() => {
            setIsDeleteClassModalOpen(false);
            setDeleteClassInput("");
            setClassToDelete(null);
          }}
          className="px-4 py-2 text-xs font-semibold transition rounded-md text-slate-600 bg-slate-100 hover:bg-slate-200"
        >
          Cancel
        </button>

        <button
          onClick={handleDeleteClass}
          disabled={
            deletingClass ||
            deleteClassInput.trim() !== classToDelete.ClassName
          }
          className={`px-4 py-2 text-xs font-semibold text-white rounded-md transition ${
            deletingClass ||
            deleteClassInput.trim() !== classToDelete.ClassName
              ? "bg-red-300 cursor-not-allowed"
              : "bg-red-600 hover:bg-red-500"
          }`}
        >
          {deletingClass ? "Deleting..." : "Delete Class"}
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

function InfoItem({ label, value }) {
  return (
    <div>
      <p className="text-xs font-medium tracking-wide uppercase text-slate-400">
        {label}
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {value}
      </p>
    </div>
  );
}

export default CourseContentLayoutInstructor;